import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Barbell, Plus, Sparkle } from "@phosphor-icons/react";

export default function SmartSlotsCard({ onAdded }) {
  const [data, setData] = useState(null);
  const [added, setAdded] = useState({});

  useEffect(() => {
    api.get("/calendar/smart-slots").then((r) => setData(r.data)).catch(() => setData({ slots: [] }));
  }, []);

  const add = async (s) => {
    await api.post("/events", { title: "Тренировка", date: s.date, time: s.start, color: "green" });
    setAdded((a) => ({ ...a, [`${s.date}${s.start}`]: true }));
    toast.success(`Тренировка добавлена: ${s.weekday}, ${s.start}`);
    onAdded?.();
  };

  if (!data || data.slots.length === 0) return null;
  return (
    <div className="glass-card p-5 mt-5" data-testid="smart-slots-card">
      <h3 className="text-sm font-semibold flex items-center gap-2 mb-1">
        <Sparkle size={16} weight="duotone" className="text-primary" /> Лучшие слоты для тренировок
      </h3>
      <p className="text-xs text-muted-foreground mb-4">
        Подобраны по прогнозу энергии Whoop, свободным окнам между встречами и вашему привычному времени.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {data.slots.map((s, i) => {
          const key = `${s.date}${s.start}`;
          const c = s.energy >= 67 ? "#00e676" : "#ffea00";
          return (
            <div key={key} className="rounded-lg border border-white/[0.07] bg-white/[0.03] p-3" data-testid={`smart-slot-${i}`}>
              <div className="flex items-center justify-between mb-1">
                <span className="text-sm font-semibold">{s.weekday}, {dayjs(s.date).format("D MMM")}</span>
                <span className="text-xs num font-bold" style={{ color: c }}>~{s.energy}%</span>
              </div>
              <div className="text-lg font-heading font-bold num mb-1.5">{s.start}–{s.end}</div>
              <ul className="text-[11px] text-muted-foreground space-y-0.5 mb-3">
                {s.reasons.map((r, j) => <li key={j}>· {r}</li>)}
              </ul>
              <button onClick={() => add(s)} disabled={added[key]} data-testid={`smart-slot-add-${i}`}
                className="w-full flex items-center justify-center gap-1.5 text-xs font-semibold py-1.5 rounded-md bg-primary/15 text-primary border border-primary/25 hover:bg-primary/25 transition-colors disabled:opacity-40">
                {added[key] ? <>Добавлено ✓</> : <><Plus size={12} /> В календарь</>}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
